import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SEC_ApiCall } from '../func.js';
import './Support.css';
import { toolsInstructions } from './toolsInstructions.js';
import { formsWorkflowInstructions } from './formsWorkflowInstructions.js';
import { performanceManagementInstructions } from './performanceManagementInstructions.js';

const supportImageFileNames = [
    'FilesDropzoneComponent.png',
    'LinksComponent.png',
    'MFA - App/Click Profile.png',
    'MFA - App/Click Setup MFA.png',
    'MFA - App/Tick checkbox.png',
    'MFA - App/Scan the QR code.png',
    'MFA - App/Enter MFA code.png',
    'MFA - App/Success Notification.png',
    'MFA - App/Remove device.png'
];

const supportCatalogue = [
    {
        moduleId: 'tools',
        moduleName: 'Tools',
        pages: [
            { pageId: 'tools-bulk-email', title: 'Bulk Email Tool', pdfUrl: '' },
        ],
    },
    {
        moduleId: 'it-support',
        moduleName: 'IT Support',
        pages: [
            { pageId: 'it-new-request', title: 'Submit New Request', pdfUrl: '' },
            { pageId: 'it-admin-requests', title: 'Manage Requests', pdfUrl: '' },
            { pageId: 'it-single-view', title: 'Request Detail View', pdfUrl: '' },
        ],
    },
    {
        moduleId: 'bookings',
        moduleName: 'Bookings',
        sections: [
            {
                sectionId: 'bookings-timeslot',
                title: 'Timeslot Bookings',
                pages: [
                    { pageId: 'bookings-timeslot-book-room-slot', title: 'Booking a room/slot', pdfUrl: '' },
                    { pageId: 'bookings-timeslot-proxy-booking', title: 'Proxy Booking', pdfUrl: '' },
                    { pageId: 'bookings-timeslot-add-attendees', title: 'Adding Attendees', pdfUrl: '' },
                    { pageId: 'bookings-timeslot-edit-booking', title: 'Edit Booking', pdfUrl: '' },
                    { pageId: 'bookings-timeslot-transfer-booking', title: 'Transfer Booking', pdfUrl: '' },
                    { pageId: 'bookings-timeslot-cancel-booking', title: 'Cancel Booking', pdfUrl: '' }
                ]
            },
            {
                sectionId: 'bookings-lesson',
                title: 'Lesson Bookings',
                pages: [
                    { pageId: 'bookings-day-view', title: 'Day View', pdfUrl: '' },
                    { pageId: 'bookings-week-view', title: 'Week View', pdfUrl: '' },
                    { pageId: 'bookings-bulk', title: 'Bulk Booking', pdfUrl: '' }
                ]
            }
        ]
    },
    {
        moduleId: 'oncall',
        moduleName: 'OnCall',
        pages: [
            { pageId: 'oncall-active', title: 'Active Calls', pdfUrl: '' },
            { pageId: 'oncall-archive', title: 'Archived Calls', pdfUrl: '' },
            { pageId: 'oncall-reports', title: 'Reports', pdfUrl: '' },
        ],
    },
    {
        moduleId: 'appsupport',
        moduleName: 'App Support',
        pages: [
            { pageId: 'appsupport-home', title: 'Support Home', pdfUrl: '' },
            { pageId: 'appsupport-create', title: 'Create Support Request', pdfUrl: '' },
        ],
    },
    {
        moduleId: 'forms',
        moduleName: 'Forms',
        sections: [
            {
                sectionId: 'forms-using',
                title: 'Using Forms',
                pages: [
                    { pageId: 'forms-complete', title: 'Complete a Form', pdfUrl: '' },
                    { pageId: 'forms-my-responses', title: 'My Responses', pdfUrl: '' },
                    { pageId: 'forms-workflow-attention', title: 'Waiting Stages and Progress Tracking', pdfUrl: '' }
                ]
            },
            {
                sectionId: 'forms-building',
                title: 'Creating and Editing',
                pages: [
                    { pageId: 'forms-create-edit', title: 'Create or Edit a Form', pdfUrl: '' },
                    { pageId: 'forms-question-types', title: 'Question Types', pdfUrl: '' },
                    { pageId: 'forms-actions-access', title: 'Actions and Access', pdfUrl: '' },
                    { pageId: 'forms-multistep-build', title: 'Build a Multi-step Form', pdfUrl: '' },
                    { pageId: 'forms-workflow-emails', title: 'Email Checkboxes and Final-page Access', pdfUrl: '' }
                ]
            },
            {
                sectionId: 'forms-responses',
                title: 'Managing Responses',
                pages: [
                    { pageId: 'forms-manage-responses', title: 'View and Action Responses', pdfUrl: '' },
                    { pageId: 'forms-workflow-manage', title: 'Reassign and Reopen Stages', pdfUrl: '' }
                ]
            }
        ]
    },
    {
        moduleId: 'performance-management',
        moduleName: 'Performance Management',
        sections: [
            {
                sectionId: 'performance-management-understanding',
                title: 'Understanding the System',
                pages: [
                    { pageId: 'pm-overview', title: 'Records, Templates and Academic Years', pdfUrl: '' },
                    { pageId: 'pm-lifecycle', title: 'Lifecycle and Statuses', pdfUrl: '' },
                    { pageId: 'pm-troubleshooting', title: 'Why Something Is Not Available', pdfUrl: '' }
                ]
            },
            {
                sectionId: 'performance-management-staff',
                title: 'For Staff',
                pages: [
                    { pageId: 'pm-create-record', title: 'Create a Record', pdfUrl: '' },
                    { pageId: 'pm-objectives', title: 'Set and Submit Objectives', pdfUrl: '' },
                    { pageId: 'pm-monitoring-final', title: 'Monitoring and Final Review', pdfUrl: '' },
                    { pageId: 'pm-cpd', title: 'Record CPD', pdfUrl: '' }
                ]
            },
            {
                sectionId: 'performance-management-managers',
                title: 'For Managers',
                pages: [
                    { pageId: 'pm-manager-review', title: 'Review Staff Records', pdfUrl: '' }
                ]
            },
            {
                sectionId: 'performance-management-administrators',
                title: 'For Administrators',
                pages: [
                    { pageId: 'pm-admin-checklist', title: 'Administrator Setup Checklist', pdfUrl: '' },
                    { pageId: 'pm-admin-years', title: 'Set Up Academic Years', pdfUrl: '' },
                    { pageId: 'pm-admin-templates', title: 'Build Templates', pdfUrl: '' },
                    { pageId: 'pm-admin-assignments', title: 'Assign Templates and Managers', pdfUrl: '' },
                    { pageId: 'pm-admin-progress', title: 'Monitor School Progress', pdfUrl: '' }
                ]
            }
        ]
    },
    {
        moduleId: 'profile',
        moduleName: 'Profile',
        pages: [
            { pageId: 'profile-mfa-app', title: 'Set up MFA (via app)', pdfUrl: '' },
            { pageId: 'profile-password', title: 'Change Password', pdfUrl: '' },
            { pageId: 'profile-image', title: 'Change Profile Photo', pdfUrl: '' },
        ],
    },
    {
        moduleId: 'rotas',
        moduleName: 'Rotas',
        pages: [
            { pageId: 'rotas-create', title: 'Creating a rota', pdfUrl: '' },
            { pageId: 'rotas-edit', title: 'Editing a rota', pdfUrl: '' },
            { pageId: 'rotas-manage-access', title: 'Managing access', pdfUrl: '' },
        ],
    },
];

/**
 * Return the first documentation page available for a module.
 * @param {Object} moduleEntry - Module record from supportCatalogue.
 * @returns {Object|null} The first available page for the module.
 */
function getFirstPageFromModule(moduleEntry) {
    if (Array.isArray(moduleEntry?.pages) && moduleEntry.pages.length > 0) {
        return moduleEntry.pages[0];
    }

    if (Array.isArray(moduleEntry?.sections) && moduleEntry.sections.length > 0) {
        const firstSectionWithPages = moduleEntry.sections.find((section) => Array.isArray(section?.pages) && section.pages.length > 0);
        if (firstSectionWithPages) {
            return firstSectionWithPages.pages[0];
        }
    }

    return null;
}

const supportInstructions = {
    ...toolsInstructions,
    ...formsWorkflowInstructions,
    ...performanceManagementInstructions,
    'forms-complete': {
        intro: 'Forms only shows forms that you have permission to complete. Open a form card, answer its questions, and submit it. Questions marked as required must be completed before the response can be sent.',
        fieldGuide: [
            { fieldName: 'Find a form', purpose: 'Forms are listed alphabetically. Use the search box to filter the cards by any part of the form name.' },
            { fieldName: 'Required questions', purpose: 'A required question must have an answer before submission. The page highlights anything that still needs completing.' },
            { fieldName: 'Files and marked images', purpose: 'Uploaded files are security scanned. An image location question asks you to select one or more supplied images and add red markers up to the limit shown for each image.' },
            { fieldName: 'Submit', purpose: 'Submitting saves a snapshot of your answers. If files need scanning, the response is accepted while those scans finish in the background.' }
        ],
        componentGuides: [
            {
                title: 'Step-by-step: complete a form',
                screenshotPlaceholder: '<INSERT_SCREENSHOT>',
                steps: [
                    'Open Forms from the main menu.',
                    'Find the form you need. Use the search box if the list is long, then select the form card.',
                    'Read the form description and complete each question. Required questions are identified on the form.',
                    'For a file question, add files through the upload area and check that every file appears before continuing.',
                    'For an image location question, select each relevant supplied image. Click or tap to add markers up to the displayed limit, or click or tap an existing marker to remove it.',
                    'Review your answers and select Submit. You return to the Forms page after the response is accepted.'
                ]
            }
        ]
    },
    'forms-my-responses': {
        intro: 'My Responses is your personal submission history. You can open it from the Forms page header, or use the My responses action on an individual form card to show only that form.',
        fieldGuide: [
            { fieldName: 'Response number', purpose: 'The easy-to-reference number assigned to the response when it was submitted.' },
            { fieldName: 'Form filter', purpose: 'Limits the history to one form. Opening My responses from a form card applies that form automatically.' },
            { fieldName: 'Response details', purpose: 'Select a response to see the answers captured at submission time, including available file preview and download controls.' },
            { fieldName: 'Archived responses', purpose: 'Responses archived by an administrator remain visible in your personal history.' }
        ],
        componentGuides: [{
            title: 'Step-by-step: review your responses',
            screenshotPlaceholder: '<INSERT_SCREENSHOT>',
            steps: ['Open Forms and select My responses.', 'Optionally choose a form to narrow the list.', 'Select a response row to view its saved answers and files.', 'Use the page controls to move through older responses.']
        }]
    },
    'forms-create-edit': {
        intro: 'Authorised form creators use a four-step editor. Create form is available from the Forms page; assigned form administrators can edit using the pencil on a form card. School-wide Forms administrators can edit any form from System Manager.',
        fieldGuide: [
            { fieldName: 'Form name and description', purpose: 'Give the form a clear name and explain when it should be used. The description is shown on the form card.' },
            { fieldName: 'Icon', purpose: 'Choose a searchable icon that makes the form easy to recognise.' },
            { fieldName: 'Questions', purpose: 'Add at least one question. Set its label, optional guidance, answer type and whether it is required.' },
            { fieldName: 'Question order', purpose: 'Use the move controls to set the order in which questions appear to respondents.' },
            { fieldName: 'Archive form', purpose: 'Archiving stops new submissions while preserving the form, its responses, files and administrator access. Archived forms can be shown and restored from Forms Administration.' }
        ],
        componentGuides: [
            { title: 'Step 1: form details', screenshotPlaceholder: '<INSERT_SCREENSHOT>', steps: ['Enter the form name and description.', 'Choose the form type and icon.', 'Continue to Questions.'] },
            { title: 'Step 2: questions', screenshotPlaceholder: '<INSERT_SCREENSHOT>', steps: ['Add and configure each question.', 'Reorder questions into the sequence respondents should follow.', 'For multi-step forms, configure the staff workflow stages.', 'Continue to Submission actions.'] },
            { title: 'Save a new or edited form', screenshotPlaceholder: '<INSERT_SCREENSHOT>', steps: ['Complete all three editor steps.', 'Review the actions and access lists.', 'Select the create or update control to save.', 'Resolve any highlighted validation messages and save again.'] }
        ]
    },
    'forms-question-types': {
        intro: 'Choose the answer type that best matches the information you need. All types can be required or optional, and every question can include guidance text for the respondent.',
        fieldGuide: [
            { fieldName: 'Short text', purpose: 'A single-line answer for brief information such as a title, room or reference.' },
            { fieldName: 'Long text', purpose: 'A multiline answer for explanations, descriptions or other detailed information.' },
            { fieldName: 'Number', purpose: 'Accepts a numeric value rather than general text.' },
            { fieldName: 'Email address', purpose: 'Accepts an email address and uses email-format validation.' },
            { fieldName: 'Date', purpose: 'Lets the respondent choose a calendar date.' },
            { fieldName: 'Time', purpose: 'Lets the respondent choose a time.' },
            { fieldName: 'Date and time', purpose: 'Collects a date and a time together.' },
            { fieldName: 'Dropdown', purpose: 'Lets the respondent choose one answer from your list. Add at least one non-empty option; duplicate options are removed when saved.' },
            { fieldName: 'Checkbox', purpose: 'Collects a simple checked or unchecked, yes/no response.' },
            { fieldName: 'Approval', purpose: 'Offers confirm and deny radio choices with custom text. In a workflow stage, the creator can also choose whether denial ends the process. See Build a Multi-step Form for the consequences.' },
            { fieldName: 'File upload', purpose: 'Lets the respondent attach files. Standard forms allow up to 10 files and 50 MB total. If full response details are emailed, the safer email limits apply across the whole submission: up to 4 PNG, JPG, JPEG, HEIC or PDF files, 5 MB each and 20 MB total.' },
            { fieldName: 'Image location marker', purpose: 'Provide up to 10 JPG or PNG source images and choose a maximum of 1-20 markers for each image. The respondent selects one or more images, clicks or taps to add markers, and clicks or taps a marker to remove it. One marked copy per selected image is saved with the response and counts toward file limits.' }
        ],
        componentGuides: [{
            title: 'Configure question-specific options',
            screenshotPlaceholder: '<INSERT_SCREENSHOT>',
            steps: ['Select the answer type.', 'For Dropdown, add every choice the respondent may select.', 'For File upload, check the displayed limit guidance; it changes if full submission emails are enabled.', 'For Image location marker, upload, name and order the source images, then set the maximum number of markers allowed on each image.', 'Choose whether the question is required.']
        }]
    },
    'forms-actions-access': {
        intro: 'Step 3 controls what happens after submission. Step 4 controls who can complete and administer the form. Every response is always saved securely; email notifications are optional.',
        fieldGuide: [
            { fieldName: 'Save to database', purpose: 'Always enabled and not configurable. It keeps each response available in Forms response history.' },
            { fieldName: 'Email notifications', purpose: 'When enabled, sends one notification to every selected internal staff member and external email address. At least one recipient is required.' },
            { fieldName: 'Receipt-only email', purpose: 'Sends notification that a response was received, including its response number, but does not include the submitted answers or files.' },
            { fieldName: 'Full-submission email', purpose: 'Includes the response details. Clean supported files are attached after security scanning; a failed scan blocks the full-response email. Enabling this option applies the reduced email attachment limits to the whole form.' },
            { fieldName: 'Internal recipients', purpose: 'Select active staff who should receive submission emails.' },
            { fieldName: 'External recipients', purpose: 'Add valid outside email addresses. Check these carefully because information sent outside the organisation cannot be retracted.' },
            { fieldName: 'Completion access', purpose: 'Staff in this list can see and submit the form, provided they also have access to the Forms module.' },
            { fieldName: 'Administration access', purpose: 'Staff in this list can edit the form and manage its responses. Administrators are automatically included in completion access.' },
            { fieldName: 'Create Forms access', purpose: 'School-wide Forms administrators manage this separately in System Manager. It permits a staff member to create forms but does not by itself enable the Forms module.' }
        ],
        componentGuides: [
            { title: 'Step 3: configure submission actions', screenshotPlaceholder: '<INSERT_SCREENSHOT>', steps: ['Leave email notifications off if responses only need to be stored in Forms.', 'To send emails, enable notifications and select internal recipients and/or add external addresses.', 'Choose receipt-only or full-submission content.', 'Review the warning and attachment limits before continuing.'] },
            { title: 'Step 4: configure access', screenshotPlaceholder: '<INSERT_SCREENSHOT>', steps: ['Select everyone who may complete the form.', 'Select the staff who may edit the form and manage responses.', 'Remember that administrators are automatically kept in completion access.', 'Save the form to synchronise the assignments to user permissions.'] }
        ]
    },
    'forms-manage-responses': {
        intro: 'Form administrators can use View responses on a form card to review live responses, record the action taken, send a confirmation to the submitter, and archive completed records.',
        fieldGuide: [
            { fieldName: 'Response counters', purpose: 'The form card shows live responses and the number still unactioned.' },
            { fieldName: 'Filters and sorting', purpose: 'Filter by responding user and actioned state, and sort by date, user or actioned state. Results are shown 25 at a time.' },
            { fieldName: 'Include archived responses', purpose: 'Reloads the list with archived records and adds archived-state filtering. Archived response details are read-only.' },
            { fieldName: 'Action response', purpose: 'Add required action notes and choose whether to email the submitter. If emailing, choose whether the action notes should be included.' },
            { fieldName: 'Archive response', purpose: 'Removes the response from the normal live admin list while retaining it in the submitter’s My Responses history.' },
            { fieldName: 'Files', purpose: 'Use separate preview or download controls where supported. Access is checked before a short-lived file link is issued.' }
        ],
        componentGuides: [
            { title: 'Review and action a response', screenshotPlaceholder: '<INSERT_SCREENSHOT>', steps: ['Select View responses on the relevant form card.', 'Use the filters or sorting controls to find a response, then select its row.', 'Review the ordered answers and any attached files.', 'For an unactioned response, open the action form and enter the required notes.', 'Choose whether to email the submitter and whether that email should include the notes.', 'Save to mark the response as actioned. The detail window remains open.'] },
            { title: 'Archive or review archived responses', screenshotPlaceholder: '<INSERT_SCREENSHOT>', steps: ['Open a live response and choose Archive response, then confirm.', 'To find it again, enable Include archived responses.', 'Use the archived filter and open the row. Archived responses can be viewed but not changed.'] }
        ]
    },
    'it-new-request': {
        intro: 'Use this form to send a new IT issue or request to the support team. Complete all required fields so the team can action your request quickly and accurately.',
        fieldGuide: [
            {
                fieldName: 'Request Title',
                purpose: 'A short summary of the issue so it can be identified quickly in request lists.'
            },
            {
                fieldName: 'Location',
                purpose: 'Where the issue is happening. Include room name/number and any useful location detail.'
            },
            {
                fieldName: 'Description',
                purpose: 'Explain the issue clearly, what happened, and what you were doing when it occurred.'
            },
            {
                fieldName: 'Required Date',
                purpose: 'The date the issue needs to be resolved by. This helps prioritise workloads.'
            },
            {
                fieldName: 'Links',
                purpose: 'Optional references such as OneDrive, Teams, SharePoint, or website URLs that help support understand the issue. Add a clear link name, paste the full URL, and use Add another link if you need to include multiple references.',
                imageFileName: 'LinksComponent.png'
            },
            {
                fieldName: 'File Upload',
                purpose: 'Optional attachments such as screenshots, documents, and evidence files related to the issue. Drag files in, click to browse, or paste a screenshot from your clipboard before submitting the request.',
                imageFileName: 'FilesDropzoneComponent.png'
            },
            {
                fieldName: 'Submit Request',
                purpose: 'Sends your request to IT Support after validation and optional file upload are complete.'
            },
        ]
    },
    'bookings-timeslot-book-room-slot': {
        intro: 'Follow these simple steps to create a timeslot booking by dragging over free cells in the room grid. Your selected range is snapped to valid 5-minute boundaries when saved.',
        fieldGuide: [],
        componentGuides: [
            {
                title: 'Step-by-step: create a timeslot booking',
                imageFileName: '',
                steps: [
                    'Select the date using the date picker at the top of the page. The timetable refreshes for the day you choose.',
                    'Check the display slot text if you need to confirm the interval being used to draw the grid rows.',
                    'Find the room column you need. Only rooms you have permission to use are shown, and you must have Edit or Manage access to create a booking in that room.',
                    'Click and drag across a free space to choose the time range. The selection tooltip shows the start time, finish time and total duration while you drag.',
                    'In the booking modal, enter the Title. This is required and is the meeting summary shown on the booking card.',
                    'Add Notes if needed. Notes are optional and can be visible to the booking owner and included in attendee emails depending on your attendee settings.',
                    'If needed, configure Proxy Booking and/or Attendees before submitting.',
                    'Click Submit to create the booking. If another user has taken the slot just before you submit, you will see a conflict message instead.',
                    'Confirm the booking card appears in the correct room and time range.',
                    'If attendees were not added, no attendee emails are sent. If attendees were added, invite emails are sent to the selected internal and external attendees.'
                ]
            }
        ]
    },
    'bookings-timeslot-add-attendees': {
        intro: 'Follow these simple steps to add attendees to a timeslot booking. You can add internal staff and external guests, and control what information appears in the invite email.',
        fieldGuide: [],
        componentGuides: [
            {
                title: 'Step-by-step: add and invite attendees',
                imageFileName: '',
                steps: [
                    'Turn on Attendees in the booking modal. If this is off, there is no attendee list and no invite emails are sent.',
                    'Use the Show notes to attendees toggle to decide whether booking notes are included in the invite email.',
                    'Use the Show other attendees in email invite toggle to decide whether other attendee names are listed in the invite email.',
                    'Select internal staff from the selector. These attendees receive invites using their school account.',
                    'Add any external guests using Name and Email. Each external attendee must include both values.',
                    'Use Add external attendee if you need more guest rows. External attendees are limited to 20 rows.',
                    'Submit the booking to send invites.',
                    'Invite emails are sent to the selected internal attendees and any external email addresses you entered.',
                    'Use the Cancel Booking guide if you later need to notify attendees about a cancellation.'
                ]
            }
        ]
    },
    'bookings-timeslot-edit-booking': {
        intro: 'Follow these simple steps to edit an existing timeslot booking. You can change booking details, attendee lists, and optionally move the booking to a new date/time after checking availability.',
        fieldGuide: [],
        componentGuides: [
            {
                title: 'Step-by-step: edit a booking',
                imageFileName: '',
                steps: [
                    'Click the pencil icon on the booking card to open the edit modal. You must have permission to edit that booking.',
                    'Update the Title if needed. This changes the booking title shown on the timetable card.',
                    'Update the Notes if needed. Notes can also be used in attendee emails depending on the privacy toggles.',
                    'If you need to change attendees, turn on Edit Attendees and update the internal and external attendee lists.',
                    'Use the Show notes to attendees and Show other attendees in email invite toggles to control what attendees can see in their emails.',
                    'If you remove any attendees, enter a cancellation reason so their cancellation email includes an explanation.',
                    'If you need to move the booking, turn on Change date/time, choose the new values, then click Check availability.',
                    'Wait for availability to be confirmed. Save changes stays blocked until the new time has been validated.',
                    'Click Save changes to apply the updates.'
                ]
            }
        ]
    },
    'bookings-timeslot-transfer-booking': {
        intro: 'Follow these simple steps to transfer an existing timeslot booking to another room in the same group without changing the booked time range.',
        fieldGuide: [],
        componentGuides: [
            {
                title: 'Step-by-step: move a booking to another room',
                imageFileName: '',
                steps: [
                    'Locate the booking card and click the transfer icon with the left-right arrows. This button appears beside the cancel icon when you have permission to transfer that booking.',
                    'In the transfer modal, choose a destination room from the room selector.',
                    'Only rooms in the same group that are currently free for the full booking time range are shown.',
                    'Click Transfer booking to confirm the move.',
                    'The system checks the target room availability again when you submit.',
                    'If the target room becomes unavailable, you will see an error and the booking stays in its original room.',
                    'If the transfer is successful, the timetable refreshes and the booking appears in the selected room.',
                    'Transfer is not available for TIMETABLED bookings.'
                ]
            }
        ]
    },
    'bookings-timeslot-proxy-booking': {
        intro: 'Follow these simple steps to create a proxy booking when you are booking on behalf of another staff member. It is only available if your account has proxy permission for Bookings.',
        fieldGuide: [],
        componentGuides: [
            {
                title: 'Step-by-step: create a proxy booking',
                imageFileName: '',
                steps: [
                    'Turn on Proxy Booking in the booking modal. When this is enabled, you must select who the booking is for.',
                    'Search for and select the staff member you are booking for.',
                    'Complete the rest of the booking details and submit the booking.',
                    'Check the booking card after it is created. It shows who the booking is for and who placed the booking.',
                    'Proxy booking changes who the booking is created for, but invite recipients are still controlled by the attendee list if attendees are enabled.'
                ]
            }
        ]
    },
    'bookings-timeslot-cancel-booking': {
        intro: 'Follow these simple steps to cancel an existing timeslot booking. Cancellation can optionally notify attendees by email.',
        fieldGuide: [],
        componentGuides: [
            {
                title: 'Step-by-step: cancel a booking',
                imageFileName: '',
                steps: [
                    'Click the bin icon on the booking card to open the cancellation modal. You must have permission to cancel that booking.',
                    'If attendees need to be notified, turn on Notify attendees via email.',
                    'If attendee notifications are enabled, you can optionally enter a cancellation reason to include in the email.',
                    'Tick the Confirm cancellation booking checkbox. The Cancel meeting button stays disabled until this is ticked.',
                    'Click Cancel meeting to submit the cancellation request.',
                    'If successful, the booking is removed from the timetable.'
                ]
            }
        ]
    },
    'profile-mfa-app': {
        intro: 'Follow these simple steps to set up MFA using an authenticator app.',
        fieldGuide: [],
        componentGuides: [
            {
                title: 'Step-by-step: set up MFA using an authenticator app',
                imageFileName: '',
                steps: [
                    {
                        text: 'Open Profile from the sidebar by clicking any of the white area or your profile image.',
                        imageFileName: 'MFA - App/Click Profile.png'
                    },
                    {
                        text: 'In the MFA section, click to set up MFA with an authenticator app.',
                        imageFileName: 'MFA - App/Click Setup MFA.png'
                    },
                    {
                        text: "Tick the 'I understand that adding a new device will make any current MFA devices inactive' box then click continue if prompted.",
                        imageFileName: 'MFA - App/Tick checkbox.png'
                    },
                    {
                        text: 'Scan the QR code in your authenticator app (or enter the setup key manually).',
                        imageFileName: 'MFA - App/Scan the QR code.png'
                    },
                    {
                        text: 'Enter the 6-digit code shown in your authenticator app.',
                        imageFileName: 'MFA - App/Enter MFA code.png'
                    },
                    {
                        text: 'Submit to complete setup.',
                        imageFileName: 'MFA - App/Enter MFA code.png'
                    },
                    {
                        text: 'Confirm MFA is now shown as enabled on your profile and that a green toast notification appears in the top right of the screen if it has been successful.',
                        imageFileName: 'MFA - App/Success Notification.png'
                    },
                    {
                        text: 'If you need to remove the device, click the Remove button on the right of the box with that device in.',
                        imageFileName: 'MFA - App/Remove device.png'
                    }
                ]
            }
        ]
    },
    'profile-password': {
        intro: 'Follow the steps below or watch the video guide to change your password.',
        fieldGuide: [],
        videoEmbed: {
            title: 'Video guide: change your password',
            src: 'https://www.youtube.com/embed/IbhY7_SZlS0?si=DyaqHb1Xr-2WgtJz'
        },
        componentGuides: [
            {
                title: 'Step-by-step: change your password',
                imageFileName: '',
                steps: [
                    'Open Profile from the sidebar.',
                    'Go to the Change Password section.',
                    'Enter your current password.',
                    'Enter your new password.',
                    'Re-enter your new password in the confirmation field.',
                    'Click the update password button.',
                    'Wait for the success message to confirm your password was changed.'
                ]
            }
        ]
    },
    'profile-image': {
        intro: 'Follow these simple steps or watch the video guide to change your profile photo.',
        fieldGuide: [],
        videoEmbed: {
            title: 'Video guide: change your profile photo',
            src: 'https://www.youtube.com/embed/3uY6Izh5mho?si=BkO8z4XpAP3Qy2s9'
        },
        componentGuides: [
            {
                title: 'Step-by-step: change your profile photo',
                imageFileName: '',
                steps: [
                    'Open Profile from the sidebar.',
                    'In the Profile Photo section, you will see your current image (or the default school logo if no image is set).',
                    'In the Profile Photo section, click Change image.',
                    'Add one image file in the uploader.',
                    'Click Save image.',
                    'Check your new photo appears on the page and in the sidebar.'
                ]
            }
        ]
    },
    'rotas-create': {
        intro: 'Use the Rotas area in System Manager to create a new rota family for your school. You can build either timetable-based or custom rotas, decide when they apply, and assign each slot before saving.',
        fieldGuide: [],
        componentGuides: [
            {
                title: 'Step-by-step: create a rota',
                imageFileName: '',
                steps: [
                    'Open System Manager and select Rotas.',
                    'Click Create New Rota to open the rota builder.',
                    'In the Rota details stage, enter a Rota name and add a Description if needed.',
                    'Choose the Status for the rota and decide whether Available on users dashboard should be turned on.',
                    'Choose the Rota type. Use timetable based if the rota should follow an existing timing set, or custom times if you want to define the time blocks yourself.',
                    'Move to the Rota cycle stage and select the Timetable cycle mode, week mode, active date range, and the days of the week the rota should apply to.',
                    'If you are creating a timetable-based rota, select the timetable timing set so the slot structure can be created for you.',
                    'Move to the Rota blocks stage and assign each slot. You can set a named person, free text, or None depending on what the rota needs to show.',
                    'Add notes to a slot if you need extra context for that block.',
                    'Click Create rota to save the rota family and return to the Rotas list.'
                ]
            }
        ]
    },
    'rotas-edit': {
        intro: 'Use edit mode when you need to update an existing rota family. You can change the rota details, update the Applies To rules, and adjust assignments before saving the new version.',
        fieldGuide: [],
        componentGuides: [
            {
                title: 'Step-by-step: edit a rota',
                imageFileName: '',
                steps: [
                    'Open System Manager and go to Rotas.',
                    'Find the rota you want to change in the Current Rotas table.',
                    'Click Edit to load that rota into the rota builder.',
                    'Review the Rota details stage and update the rota name, description, status, or dashboard availability if needed.',
                    'Use the Rota cycle stage to adjust timing set, cycle mode, week rules, date range, or active days when the rota schedule needs to change.',
                    'Open the Rota blocks stage and update the assignments for any slot that has changed.',
                    'For timetable-based rotas, click a timetable slot to update the assigned person, text value, or notes.',
                    'For custom rotas, update the row values directly and add or remove rows if the rota structure needs to change.',
                    'Check the summary and block setup carefully, especially if the rota uses multiple timetable weeks.',
                    'Click Update rota to save your changes.'
                ]
            }
        ]
    },
    'rotas-manage-access': {
        intro: 'Use Manage Access from the Rotas home page to control who can view or edit each rota family. Access is managed per member of staff and updates take effect for that rota family.',
        fieldGuide: [],
        componentGuides: [
            {
                title: 'Step-by-step: manage rota access',
                imageFileName: '',
                steps: [
                    'Open System Manager and go to Rotas.',
                    'Find the rota family you want to manage in the Current Rotas table.',
                    'Click Manage Access to open the Staff Permissions window.',
                    'Wait for the staff list to load for that rota family.',
                    'Use the Filters panel if you want to narrow the list to users with a specific access level.',
                    'Use the Search staff box to quickly find a member of staff by name.',
                    'Choose the required access level for that user from the dropdown.',
                    'Use None to remove access, View self only to limit users to their own assignments, View all to allow read-only access to the full rota, or Edit to allow changes.',
                    'Wait for the Updating state to finish and the success toast to confirm the new permission has been saved.',
                    'Repeat for any other staff members, then close the window when you are finished.'
                ]
            }
        ]
    }
};

export default function Docs() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const defaultModule = supportCatalogue[0];
    const defaultPage = getFirstPageFromModule(defaultModule);

    const [expandedModuleId, setExpandedModuleId] = useState(defaultModule?.moduleId || '');
    const [selectedPage, setSelectedPage] = useState(defaultPage);
    const [expandedSectionKey, setExpandedSectionKey] = useState('');
    const [supportImagesByName, setSupportImagesByName] = useState({});
    const [expandedImage, setExpandedImage] = useState(null);
    const queryModuleId = String(searchParams.get('module') || '').trim().toLowerCase();

    const activeModule = useMemo(() => {
        return supportCatalogue.find(moduleEntry => moduleEntry.moduleId === expandedModuleId) || supportCatalogue[0];
    }, [expandedModuleId]);

    const selectedPageInstructions = supportInstructions[selectedPage?.pageId];

    useEffect(() => {
        let ignore = false;

        async function loadSupportImages() {
            try {
                const response = await SEC_ApiCall('appsupport/images', {
                    fileNames: supportImageFileNames.join(',')
                });

                const imageArray = Array.isArray(response?.images) ? response.images : [];
                const imageMap = {};

                imageArray.forEach((item) => {
                    if (item?.fileName && item?.url) {
                        imageMap[item.fileName] = item.url;
                    }
                });

                if (!ignore) {
                    setSupportImagesByName(imageMap);
                }
            } catch (error) {
                if (!ignore) {
                    setSupportImagesByName({});
                }
            }
        }

        loadSupportImages();

        return () => {
            ignore = true;
        };
    }, []);

    useEffect(() => {
        if (!queryModuleId) {
            return;
        }

        const matchedModule = supportCatalogue.find((moduleEntry) => String(moduleEntry?.moduleId || '').toLowerCase() === queryModuleId);
        if (!matchedModule) {
            return;
        }

        const firstModulePage = getFirstPageFromModule(matchedModule);
        if (!firstModulePage) {
            return;
        }

        setExpandedModuleId(matchedModule.moduleId);
        setSelectedPage(firstModulePage);

        const firstSectionId = matchedModule?.sections?.[0]?.sectionId;
        if (firstSectionId) {
            setExpandedSectionKey(`${matchedModule.moduleId}:${firstSectionId}`);
        } else {
            setExpandedSectionKey('');
        }
    }, [queryModuleId]);

    function onModuleClick(moduleId) {
        if (expandedModuleId === moduleId) {
            setExpandedModuleId('');
            setExpandedSectionKey('');
            return;
        }
        setExpandedModuleId(moduleId);
        const selectedModule = supportCatalogue.find(moduleEntry => moduleEntry.moduleId === moduleId);
        const firstModulePage = getFirstPageFromModule(selectedModule);
        if (firstModulePage) {
            setSelectedPage(firstModulePage);
        }

        const firstSectionId = selectedModule?.sections?.[0]?.sectionId;
        if (firstSectionId) {
            setExpandedSectionKey(`${moduleId}:${firstSectionId}`);
        } else {
            setExpandedSectionKey('');
        }
    }

    // Toggle a second-level section and select its first page when available.
    function onSectionClick(moduleId, section) {
        const sectionKey = `${moduleId}:${section.sectionId}`;
        if (expandedSectionKey === sectionKey) {
            setExpandedSectionKey('');
            return;
        }

        setExpandedSectionKey(sectionKey);
        if (Array.isArray(section?.pages) && section.pages.length > 0) {
            setSelectedPage(section.pages[0]);
        }
    }

    function onPageClick(page) {
        setSelectedPage(page);
    }

    /**
     * Open the support image preview overlay for a selected image.
     * @param {string} imageUrl - Presigned image URL to preview.
     * @param {string} imageAlt - Accessible label for the selected image.
     * @returns {void}
     */
    function onSupportImageClick(imageUrl, imageAlt) {
        if (!imageUrl) {
            return;
        }

        setExpandedImage({
            url: imageUrl,
            alt: imageAlt || 'Support screenshot'
        });
    }

    /**
     * Close the support image preview overlay.
     * @returns {void}
     */
    function closeExpandedImage() {
        setExpandedImage(null);
    }

    /**
     * Normalize guide step content so both legacy string steps and
     * image-backed step objects can be rendered in the same list.
     * @param {string|Object} stepRow - Raw step definition from the guide.
     * @returns {{ text: string, imageFileName: string }} Normalized step data.
     */
    function getSupportStepContent(stepRow) {
        if (typeof stepRow === 'string') {
            return {
                text: stepRow,
                imageFileName: ''
            };
        }

        return {
            text: String(stepRow?.text || ''),
            imageFileName: String(stepRow?.imageFileName || '')
        };
    }

    return (
        <div className='support-page'>
            <div className='support-top-actions'>
                <button
                    type='button'
                    className='support-return-button'
                    onClick={() => navigate('/app/support')}
                >
                    Return to Support Home
                </button>
            </div>
            <div className='support-shell'>
                <aside className='support-sidebar'>
                    <h1 className='support-title'>Docs</h1>
                    <p className='support-subtitle'>Module guides and page documentation</p>

                    {supportCatalogue.map((moduleEntry) => (
                        <div key={moduleEntry.moduleId} className='support-module-block'>
                            <button
                                type='button'
                                className='support-module-button'
                                onClick={() => onModuleClick(moduleEntry.moduleId)}
                            >
                                <span>{moduleEntry.moduleName}</span>
                                <span>{expandedModuleId === moduleEntry.moduleId ? '−' : '+'}</span>
                            </button>

                            {expandedModuleId === moduleEntry.moduleId && (
                                <div className='support-page-list'>
                                    {Array.isArray(moduleEntry.pages) && moduleEntry.pages.map((page) => (
                                        <button
                                            type='button'
                                            key={page.pageId}
                                            className={selectedPage?.pageId === page.pageId ? 'support-page-button support-page-button-active' : 'support-page-button'}
                                            onClick={() => onPageClick(page)}
                                        >
                                            {page.title}
                                        </button>
                                    ))}

                                    {Array.isArray(moduleEntry.sections) && moduleEntry.sections.map((section) => {
                                        const sectionKey = `${moduleEntry.moduleId}:${section.sectionId}`;
                                        const sectionOpen = expandedSectionKey === sectionKey;
                                        return (
                                            <div key={section.sectionId} className='support-section-list'>
                                                <button
                                                    type='button'
                                                    className='support-section-button'
                                                    onClick={() => onSectionClick(moduleEntry.moduleId, section)}
                                                >
                                                    <span>{section.title}</span>
                                                    <span>{sectionOpen ? '−' : '+'}</span>
                                                </button>

                                                {sectionOpen && (
                                                    <div className='support-section-page-list'>
                                                        {Array.isArray(section.pages) && section.pages.length > 0 && section.pages.map((page) => (
                                                            <button
                                                                type='button'
                                                                key={page.pageId}
                                                                className={selectedPage?.pageId === page.pageId ? 'support-page-button support-page-button-active' : 'support-page-button'}
                                                                onClick={() => onPageClick(page)}
                                                            >
                                                                {page.title}
                                                            </button>
                                                        ))}
                                                        {(!Array.isArray(section.pages) || section.pages.length === 0) && (
                                                            <p className='support-section-empty'>No pages added yet.</p>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    ))}
                </aside>

                <section className='support-viewer-panel'>
                    <div className='support-viewer-header'>
                        <div>
                            <h2 className='support-viewer-title'>{selectedPage?.title || 'Select a support page'}</h2>
                            <p className='support-viewer-subtitle'>{activeModule?.moduleName || 'Module'} documentation</p>
                        </div>
                    </div>

                    {selectedPageInstructions && (
                        <div className='support-instruction-content'>
                            <p className='support-intro'>{selectedPageInstructions.intro}</p>

                            {selectedPageInstructions.videoEmbed?.src && (
                                <div className='support-video-card'>
                                    <h3 className='support-video-title'>{selectedPageInstructions.videoEmbed.title}</h3>
                                    <div className='support-video-frame-wrap'>
                                        <iframe
                                            className='support-video-frame'
                                            src={selectedPageInstructions.videoEmbed.src}
                                            title={selectedPageInstructions.videoEmbed.title}
                                            frameBorder='0'
                                            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                                            referrerPolicy='strict-origin-when-cross-origin'
                                            allowFullScreen
                                        />
                                    </div>
                                </div>
                            )}

                            {Array.isArray(selectedPageInstructions.fieldGuide) && selectedPageInstructions.fieldGuide.length > 0 && (
                                <div className='support-section'>
                                    <h3 className='support-section-title'>Field Guide</h3>
                                    <div className='support-field-list'>
                                        {selectedPageInstructions.fieldGuide.map((fieldRow) => (
                                            <div key={fieldRow.fieldName} className='support-field-row'>
                                                <p className='support-field-name'>{fieldRow.fieldName}</p>
                                                <p className='support-field-purpose'>{fieldRow.purpose}</p>
                                                {fieldRow.imageFileName && supportImagesByName[fieldRow.imageFileName] && (
                                                    <>
                                                        <img
                                                            className='support-component-image support-component-image-clickable'
                                                            src={supportImagesByName[fieldRow.imageFileName]}
                                                            alt={fieldRow.fieldName}
                                                            onClick={() => onSupportImageClick(supportImagesByName[fieldRow.imageFileName], fieldRow.fieldName)}
                                                        />
                                                        <p className='support-image-caption'>Click to enlarge</p>
                                                    </>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {Array.isArray(selectedPageInstructions.componentGuides) && selectedPageInstructions.componentGuides.length > 0 && (
                                <div className='support-section'>
                                    {selectedPageInstructions.componentGuides.map((guideRow) => (
                                        <div key={guideRow.title} className='support-component-card'>
                                            <h4 className='support-component-title'>{guideRow.title}</h4>
                                            <div className='support-component-body'>
                                                {supportImagesByName[guideRow.imageFileName] && (
                                                    <>
                                                        <img
                                                            className='support-component-image support-component-image-clickable'
                                                            src={supportImagesByName[guideRow.imageFileName]}
                                                            alt={guideRow.title}
                                                            onClick={() => onSupportImageClick(supportImagesByName[guideRow.imageFileName], guideRow.title)}
                                                        />
                                                        <p className='support-image-caption'>Click to enlarge</p>
                                                    </>
                                                )}
                                                {guideRow.screenshotPlaceholder && (
                                                    <div className='support-screenshot-placeholder' role='note'>
                                                        {guideRow.screenshotPlaceholder}
                                                    </div>
                                                )}
                                                <ol className='support-component-steps'>
                                                    {guideRow.steps.map((stepRow, index) => {
                                                        const stepContent = getSupportStepContent(stepRow);

                                                        return (
                                                            <li key={`${guideRow.title}-${index}`} className='support-step-item'>
                                                                <span>{stepContent.text}</span>
                                                                {stepContent.imageFileName && supportImagesByName[stepContent.imageFileName] && (
                                                                    <>
                                                                        <img
                                                                            className='support-step-image support-component-image-clickable'
                                                                            src={supportImagesByName[stepContent.imageFileName]}
                                                                            alt={stepContent.text}
                                                                            onClick={() => onSupportImageClick(supportImagesByName[stepContent.imageFileName], stepContent.text)}
                                                                        />
                                                                        <p className='support-image-caption'>Click to enlarge</p>
                                                                    </>
                                                                )}
                                                            </li>
                                                        );
                                                    })}
                                                </ol>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                            <div className='support-feedback-card'>
                                <h3 className='support-feedback-title'>We're always after your view</h3>
                                <p className='support-feedback-text'>
                                    If you have an idea, suggestion or an improvement to School Engine please submit a App Support request
                                </p>
                                <button
                                    type='button'
                                    className='support-feedback-button'
                                    onClick={() => navigate('/app/support/requests/new')}
                                >
                                    Submit App Support Request
                                </button>
                                <p className='support-feedback-contact'>
                                    If you need to contact us for anything please email support@schoolengine.co.uk
                                </p>
                            </div>
                        </div>
                    )}

                    {selectedPage?.pdfUrl && (
                        <iframe
                            title='Support PDF Viewer'
                            className='support-pdf-frame'
                            src={selectedPage.pdfUrl}
                        />
                    )}
                </section>
            </div>

            {expandedImage && (
                <div className='support-image-modal' onClick={closeExpandedImage}>
                    <div className='support-image-modal-card' onClick={(event) => event.stopPropagation()}>
                        <button
                            type='button'
                            className='support-image-modal-close'
                            onClick={closeExpandedImage}
                        >
                            Close
                        </button>
                        <img
                            className='support-image-modal-image'
                            src={expandedImage.url}
                            alt={expandedImage.alt}
                        />
                    </div>
                </div>
            )}
        </div>
    )
};
